import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Label from '../Label';
import colors from '../../colors';
import { AshLabel } from '../Label/Label';

const Container = styled.div`
  width: ${({ width }) => width || '100%'};
`;

const StyledTextInput = styled.input.attrs({
  type: 'text',
})`
  -webkit-appearance: none;
  border: 1px solid ${colors.smoke};
  border-radius: 3px;
  color: ${colors.ash};
  display: block;
  font-family: 'Quicksand', sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 10px;
  width: 100%;

  ::placeholder {
    color: ${colors.smoke};
  }

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(217, 217, 217, 0.5);
  }

  &:active,
  &:focus {
    color: ${colors.charcoal};
    border-color: ${colors.primary};
    outline: 0;
  }

  &:disabled {
    background-color: ${colors.pearl};
    border-color: ${colors.cloud};
    box-shadow: none;
    color: ${colors.smoke};
    cursor: default;
  }
`;

const TextInput = ({ width, label, onChange, ash, ...inputProps }) => (
  <Container width={width}>
    {label && !ash && <Label htmlFor={inputProps.id}>{label}</Label>}
    {label && ash && <AshLabel htmlFor={inputProps.id}>{label}</AshLabel>}
    <StyledTextInput
      onChange={(changeEvent) => onChange(changeEvent.target.value)}
      {...inputProps}
    />
  </Container>
);

TextInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.string,
  ash: PropTypes.bool,
};

TextInput.defaultProps = {
  label: null,
  onChange: () => {},
  width: null,
  ash: false,
};

export default TextInput;
